import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TArticleSectionClickEventParams } from './_types';

export const articleSectionClickEvent = (
  params: TArticleSectionClickEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_CLICK_FROM_CATEGORY,
    params,
  });
};
